<div class="main-content d-flex flex-column" id="stats-filters-container">
  <div class="d-flex flex-row w-100 header justify-content-between">
    <div>
      <span class="title1">Filtros</span>
    </div>
    <div>
      <div (click)="CloseMenu()" class="close-icon">
        <img src="../../../assets/Icons/close-line.png" alt="Fechar janela de filtros">
      </div>
    </div>
  </div>
  <div class="search-topics">
    <!-- Sub-client -->
    @if (subClients.length) {
      <div class="search-topic">
        <h4 class="filter-title">Unidade</h4>
        <mat-form-field>
          <mat-select [(ngModel)]="selectedSubClientId" name="subClientSelect"
            aria-label="Seleção de sub-cliente" id="subClientSelect">
            <mat-option [value]="ALL_SUB_CLIENTS">Todas as unidades</mat-option>
            @for (client of subClients; track client.nCliente) {
              <mat-option [value]="client.nCliente">
                {{ client.nCliente }} - {{ client.nome }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }

    <!-- Product-->
    <div class="search-topic">
      <h4 class="filter-title">Produto</h4>
      <mat-form-field style="height: 40px;">
        <input style="justify-content: center;" type="text" matInput [formControl]="productControl"
          [matAutocomplete]="productAuto" aria-label="Pesquisa por produto" />
          <mat-autocomplete #productAuto="matAutocomplete" (optionSelected)="SelectedProduct($event)"
            [displayWith]="DisplayProduct">

            @for (option of filteredProductOptions | async | slice : 0 : 100; track option) {
              <mat-option [value]="option">
                {{ option.memoria }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>

        @if (selectedProducts.length) {
          <div class="selected-products-chips" role="list" aria-label="Produtos selecionados">
            @for (p of selectedProducts; track p.referencia) {
              <span class="product-chip" role="listitem">
                <span class="product-chip-label" [title]="p.memoria">{{ p.memoria }}</span>
                <button type="button" class="product-chip-remove"
                  (click)="RemoveSelectedProduct(p)"
                  [attr.aria-label]="'Remover ' + p.memoria">×</button>
              </span>
            }
          </div>
        }
      </div>

      <!-- Laboratories -->
      @if (this.profileRequest.role !== 'Laboratorio') {
        <div class="search-topic">
          <h4 class="filter-title">Laboratório</h4>
          <mat-form-field>
            <input style="justify-content: center;" type="text" aria-label="Pesquisa por laboratório" matInput [formControl]="laboratoryControl"
              [matAutocomplete]="labAuto" />
              <mat-autocomplete #labAuto="matAutocomplete" (optionSelected)="SelectedLaboratory($event)"
                [displayWith]="DisplayLaboratory">
                @for (option of filteredLaboratoryOptions | async ; track option) {
                  <mat-option [value]="option">
                    {{ option.labName }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </div>
        }

        <!-- Substances -->
        <div class="search-topic">
          <h4 class="filter-title">Substância</h4>
          <mat-form-field>
            <input style="justify-content: center;" type="text" aria-label="Pesquisa por substância" matInput [formControl]="substanceControl"
              [matAutocomplete]="subAuto" />
              <mat-autocomplete #subAuto="matAutocomplete" (optionSelected)="SelectedSubstance($event)"
                [displayWith]="DisplaySubstance">
                @for (option of filteredSubstanceOptions | async | slice : 0 : 100; track option) {
                  <mat-option [value]="option">
                    {{ option.nome }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </div>

          <!-- Addresses -->
          <div class="search-topic">
            <h4 class="filter-title">Moradas</h4>
            <mat-form-field>
              <mat-select [(ngModel)]="selectedAddress" name="addressesSelect" aria-label="Seleção de morada de entrega" id="addressesSelect">
                @for (address of deliveryAddressList; track address) {
                  <mat-option [value]="address">
                    {{address.address}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>


          <!-- Start Date-->
          <div class="search-topic">
            <h4 class="filter-title">Data de Início</h4>
            <mat-form-field>
              <input matInput [matDatepicker]="startDatePicker" aria-labelledby="Data de início" [(ngModel)]="startDate" name="startDate">
              <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #startDatePicker aria-haspopup="dialog"></mat-datepicker>
            </mat-form-field>
          </div>

          <!-- End Date -->
          <div class="search-topic">
            <h4 class="filter-title">Data de Fim</h4>
            <mat-form-field>
              <input matInput [matDatepicker]="endDatePicker" aria-labelledby="Data de fim" [(ngModel)]="endDate" name="endDate">
              <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #endDatePicker aria-haspopup="dialog"></mat-datepicker>
            </mat-form-field>
          </div>

          <!-- Year -->
          <div class="search-topic">
            <h4 class="filter-title">Ano</h4>
            <mat-form-field>
              <mat-select [(ngModel)]="selectedYear" (selectionChange)="OnYearChange($event.value)" aria-label="Seleção de ano de pesquisa" name="yearSelect" id="yearSelect">
                @for (year of yearsList; track year) {
                  <mat-option [value]="year">
                    {{year}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="filter-actions">
          <div class="btn-apply" aria-label="Pesquisar estatísticas" (click)="SearchStats()"><span>Aplicar</span></div>
          <div class="btn-clear" aria-label="Limpar filtros" (click)="ClearFilters()"><span>Limpar filtros</span></div>
        </div>
      </div>
